import "./styles/property-table.scss";
appHost.plugins.register({
    // #region Vars
    name: "288a.web.cms",
    // #endregion
    // #region Register
    register() {
        // #region layouts
        appHost.components.registerAsync("g-cms-form-page", () => import(/* webpackChunkName: "web-cms" */ "./views/g-cms-form-page.vue").then(_ => _.default));
        appHost.components.registerAsync("g-property-grid", () => import(/* webpackChunkName: "web-cms" */ "./views/g-property-grid.vue").then(_ => _.default));
        // #endregion
    },
    // #endregion
});
